import businessClient from 'src/services/clients/business'
import { IMeta, IDiscountListItem } from 'src/common/interfaces/index.js'

const IDiscountListResponse = { meta: IMeta, data: { list: [IDiscountListItem] } }

export const inventoryDiscount = {
  /**
   * @param {{}} object
   * @return {IDiscountListResponse}
   */
  list(filter = {}, signal) {
    return businessClient().post('discount/portal/list', { filter }, { signal })
  },

  /**
   * @param {IDiscountListItem} data
   * @return
   */
  upsert(data = {}, signal) {
    return businessClient().post('discount/upsert', { data }, { signal })
  },
}
